import { apiSlice } from "features/api/apiSlice";
import { transformDoctorWithSlots } from "./transformDoctorWithSlots";

const getDoctorWithSlots = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDoctorWithSlots: build.query({
      query: (id) => `/doctors/mwell/${id}`,
      transformResponse: (res) => transformDoctorWithSlots(res.d.data),
      providesTags: (result) =>
        result ? [{ type: "Doctor", id: result.id }] : ["Doctor"],
    }),
  }),
});

export const { useGetDoctorWithSlotsQuery } = getDoctorWithSlots;
